<template>
  <div id="login-wrapper"
       class="fill-height">

    <video-background>
    
      <v-container class="pt-10 mx-auto fill-height"
                   style="max-width: 500px">
        <v-card rounded="xl"
                class="px-5 py-3">
          
          <v-card-title class="text-center d-block text-h5 font-weight-bold py-10">
            <Logo :height="100"/>
          </v-card-title>
          
          <v-card-text>

            <p class="text-center text-h6 black--text">
              Accedi utilizzando il tuo Zwan ID
            </p>

            <v-form @submit="onSubmit"
                    :disabled="isLogging">

              <v-alert type="error" 
                       v-if="error"
                       class="mb-10">
                Le credenziali inserite non sono corrette.
              </v-alert>

              <v-row>
                <!-- email -->
                <v-col cols="12">
                  <v-text-field
                    v-model="form.email"
                    type="email"
                    label="Zwan ID"
                    @keyup.enter="onSubmit"
                    @keyup="$v.form.email.$touch()"
                    :error="$v.form.email.$error"
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <!-- password -->
                <v-col cols="12">
                  <v-text-field
                    v-model="form.password"
                    :type="showPassword?'text':'password'"
                    label="Password"
                    @keyup.enter="onSubmit"
                    @keyup="$v.form.password.$touch()"
                    :error="$v.form.password.$error"
                    outlined
                    hide-details
                    :append-icon="showPassword?'mdi-eye-off':'mdi-eye'"
                    @click:append="showPassword=!showPassword"
                  ></v-text-field>
                </v-col>
                <!-- buttons -->
                <v-col cols="12"
                       class="text-center">
                  
                  <!-- submit -->
                  <v-btn large
                         color="primary"
                         depressed
                         @click="onSubmit"
                         :disabled="!canSubmit"
                         :loading="isLogging">
                    Accedi
                    <v-icon class="ml-2">
                      mdi-chevron-right
                    </v-icon>
                  </v-btn>

                  <!-- password -->
                  <v-btn block
                         text
                         class="mt-5"
                         href="https://store.zwan.it/reset-password"
                         target="_blank">
                    Non ricordi la password?
                  </v-btn>

                </v-col>
              </v-row>
            </v-form>

          </v-card-text>
        
        </v-card>
      </v-container>

    </video-background>

  </div>
</template>

<style lang="scss">
  #login-wrapper {
    background: #eee;
  }
</style>

<script>
import utility from '@/mixins/utility'

import { required, email } from 'vuelidate/lib/validators'

import { mapActions } from 'vuex'

import Logo from '@/components/Logo'
import VideoBackground from '@/components/VideoBg'

export default {
  
  name: 'Login',

  mixins: [ utility ],

  components:
  {
    Logo,
    VideoBackground
  },

  data: () => ({
    error: false,
    form: {
      email: null,
      password: null
    },
    isLogging: false,
    showPassword: false
  }),
  
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required
      }
    }
  },

  computed:
  {
    canSubmit()
    {
      // non ho ancora compilato i campi
      if( !this.$v.form.$dirty )
        return false

      return !this.$v.form.$anyError
    }
  },

  methods: 
  {
    ...mapActions({
      login: 'auth/login'
    }),

    onSubmit()
    {
      this.$v.form.$touch()

      if( !this.canSubmit )
        return false

      this.isLogging = true

      this.error = false

      this.login(this.form)
          .then(()=>this.goTo('home'))
          .catch(()=>this.error=true)
          .finally(()=>this.isLogging=false)
   } 
  },

  mounted()
  {
    
  },

  watch:
  {
    
  }

}
</script>
